<template>
  <section :class="sectionClasses" :style="'background-color: ' + backgroundColor">
    <div class="row justify-content-center align-items-center text-center">
      <div class="text-container col-12 d-flex justify-content-center align-items-center">
        <h3 :style="'color: ' + textColor">{{ text }}</h3>
        <div v-if="$slots.default" class="slot-wrapper">
          <slot></slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "call-to-action-section",
  props: {
    text: {
      type: String,
      description: "Call to action text"
    },
    fullWidth: {
      type: Boolean,
      default: true,
      description: "Make the section full width"
    },
    textColor: {
      type: String,
      default: "white",
      description: "Text color."
    },
    backgroundColor: {
      type: String,
      default: "black",
      description: "Background color."
    }
  },
  computed: {
    sectionClasses: function() {
      return this.fullWidth
        ? "py-4 pb-4 px-4"
        : "py-4 pb-4 px-4 container rounded";
    }
  }
};
</script>

<style scoped lang="scss">
.text-container {
  flex-direction: row;

  h3 {
    margin: 0 1rem 0;
    color: white;
  }
}

@media (max-width: 575.98px) {
  .rounded {
    border-radius: 0 !important;
  }

  .btn {
    display: block;
  }

  .slot-wrapper {
    margin-top: 1rem;
  }

  .text-container {
    flex-direction: column;

    h3 {
      margin: 0;
      font-size: .9rem;
    }
  }
}
</style>
